/* eslint-disable no-underscore-dangle */
import {
  AccountId,
  AccountManagerInfo,
  AccountMetainfo,
  ActionMetaInfo,
  Brackets,
  ConnectionStatus,
  CustomInputFieldsValues,
  DefaultContextMenuActionsParams,
  Execution,
  IBrokerConnectionAdapterHost,
  IBrokerTerminal,
  InstrumentInfo,
  INumberFormatter,
  IsTradableResult,
  Order,
  PlaceOrderResult,
  Position,
  PreOrder,
  TradeContext,
} from 'charting_library_trading_platform/charting_library';
import { PRIVATE_SOCKET_ACTIONS } from 'reducers/helpers/trade';
import { OpenPosition } from 'types/IOpenPosition';
import { OpenStopOrders } from 'types/IOpenStopOrders';

export type UpdatePositionOrderType = keyof typeof PRIVATE_SOCKET_ACTIONS | 'SNAPSHOT';

export abstract class AbstractBroker implements IBrokerTerminal {
  protected readonly _host: IBrokerConnectionAdapterHost;

  constructor(host: IBrokerConnectionAdapterHost) {
    this._host = host;
  }

  abstract setActiveSymbol(symbol: string): void;

  abstract orders(): Promise<Order[]>;

  abstract positions(): Promise<Position[]>;

  abstract modifyOrder(order: Order, confirmId?: string): Promise<void>;

  abstract cancelOrder(orderId: string): Promise<void>;

  abstract closePosition(positionId: string, amount?: number): Promise<void>;

  abstract chartContextMenuActions(
    context: TradeContext,
    options?: DefaultContextMenuActionsParams
  ): Promise<ActionMetaInfo[]>;

  abstract isTradable(symbol: string): Promise<boolean | IsTradableResult>;

  abstract connectionStatus(): ConnectionStatus;

  abstract executions(symbol: string): Promise<Execution[]>;

  abstract symbolInfo(symbol: string): Promise<InstrumentInfo>;

  abstract accountManagerInfo(): AccountManagerInfo;

  abstract accountsMetainfo(): Promise<AccountMetainfo[]>;

  abstract currentAccount(): AccountId;

  abstract placeOrder(order: PreOrder): Promise<PlaceOrderResult>;

  abstract quantityFormatter(symbol: string): Promise<INumberFormatter>;

  abstract spreadFormatter(symbol: string): Promise<INumberFormatter>;

  abstract formatter(symbol: string): Promise<INumberFormatter>;

  abstract handleUpdatePositions(
    position: OpenPosition,
    type: UpdatePositionOrderType
  ): void;

  abstract handleUpdateOrders(order: OpenStopOrders, type: UpdatePositionOrderType): void;

  abstract handlePLUpdate(positionId: string, markPrice: number): void;

  abstract editPositionBrackets(
    positionId: string,
    brackets: Brackets,
    customFields?: CustomInputFieldsValues
  ): Promise<void>;

  abstract showNotification(title: string, message: string): void;
}
